// extracted by mini-css-extract-plugin
export default {"hypnotic_loader":"styles_hypnotic_loader__DH3+z","loadhypnotic":"styles_loadhypnotic__5+H8N","loader_all":"styles_loader_all__b2lZX"};